import React, { useEffect, useState } from "react";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";

function CSAE() {
  return (
    <div>
      <Header />
      <div className="contact-section">
        <div
          className="contact-top padding-tb aside-bg"
          style={{
            "margin-left": "20px",
            "margin-right": "20px",
            "padding-top": "200px",
          }}
        >
          <div className="vc_row wpb_row vc_row-fluid vc_custom_1497013187222">
            <div className="row-container vc_row-flex row-default vc_row">
              <div className="wpb_column vc_column_container vc_col-sm-12">
                <div className="vc_column-inner ">
                  <div className="wpb_wrapper policy-wrapper">
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <h2>
                          Tegal's Commitment to Preventing Child Sexual Abuse
                          and Exploitation
                        </h2>
                      </div>
                    </div>

                    <div class="wpb_text_column wpb_content_element ">
                      <div class="wpb_wrapper">
                        <p>
                          At Tegal, we are deeply committed to ensuring the
                          safety and well-being of all our users, particularly
                          children. We recognize the importance of protecting
                          children from sexual abuse and exploitation, and we
                          take our responsibility in this regard very seriously.
                        </p>

                        <h2>Our Commitment</h2>
                        <p>
                          Tegal is committed to preventing child sexual abuse
                          and exploitation on our platform. We have implemented
                          the following measures to ensure a safe and secure
                          environment for all our users:
                        </p>

                        <ul>
                          <li>
                            1. Age Verification: We require all users to verify
                            their age before creating an account on Tegal. This
                            ensures that minors are not able to access our
                            platform.
                          </li>
                          <li>
                            2. Content Moderation: We have a team of moderators
                            who review all content uploaded to our platform to
                            ensure that it does not contain any explicit or
                            harmful material.
                          </li>
                          <li>
                            3. Reporting Mechanism: We provide a reporting
                            mechanism for users to report any suspicious or
                            inappropriate behavior. All reports are reviewed and
                            addressed promptly.
                          </li>
                          <li>
                            4. Partnership with Law Enforcement: We work closely
                            with law enforcement agencies to report and address
                            any instances of child sexual abuse or exploitation.
                          </li>
                          <li>
                            5. User Education: We provide educational resources
                            and guidelines to our users on how to stay safe
                            online and report any suspicious behavior.
                          </li>
                        </ul>

                        <h2>Our Policy</h2>

                        <p>
                          Tegal has a zero-tolerance policy towards child sexual
                          abuse and exploitation. Any user found to be engaging
                          in such behavior will be immediately reported to law
                          enforcement and banned from our platform.
                        </p>

                        <h2>Reporting CSAE</h2>

                        <p>
                          If you suspect or have evidence of child sexual abuse
                          or exploitation on Tegal, please report it to us
                          immediately at hello@tegalapp.com. You can also report
                          it to the National Center for Missing and Exploited
                          Children (NCMEC) at ncmec@gov.ng or call our direct
                          line via +2349043205555
                        </p>

                        <h2>Conclusion</h2>
                        <p>
                          At Tegal, we are committed to creating a safe and
                          secure environment for all our users. We take our
                          responsibility to prevent child sexual abuse and
                          exploitation very seriously, and we will continue to
                          work tirelessly to ensure that our platform remains a
                          safe space for everyone.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
}

export default CSAE;
